import { useSelector } from 'react-redux';
import { useLanguageCode } from '@mews-commander/core';
import { getCurrentDateTimeLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { GlobalizationContextProvider } from '@mews/framework';
import { getTextLocalizationInfo } from '../../core/globalization/selectors';

export const GlobalizationProvider = ({ children }: React.PropsWithChildren<{}>) => {
    const timezone: string = useSelector(getCurrentEnterpriseIanaTimeZoneIdentifier);
    const dateTimeLocalizationInfo = useSelector(getCurrentDateTimeLocalizationInfo);
    const languageCode = useLanguageCode();
    const textLocalizationInfo = useSelector(getTextLocalizationInfo);

    return (
        <GlobalizationContextProvider
            dateTimeLocalizationInfo={dateTimeLocalizationInfo}
            languageCode={languageCode}
            timezone={timezone}
            textLocalizationInfo={textLocalizationInfo}
        >
            {children}
        </GlobalizationContextProvider>
    );
};
